<template>
  <div class="box">
    <Card>
      <p slot="title">
        <Icon type="ios-settings"></Icon>
        Settings
      </p>
      <Form ref="form" :model="formData" :rules="formRules" :label-width="120">
        <Form-item label="DSP Username" prop="dsp_username">
          <Input v-model.trim="formData.dsp_username" placeholder="Enter DSP username"></Input>
        </Form-item>
        <Form-item>
          <Button type="primary" @click="handleSubmit">Save</Button>
        </Form-item>
      </Form>
    </Card>
  </div>
</template>

<script>
export default {
  name: "setting",
  data() {
    return {
      formData: {
        dsp_username: ""
      },
      formRules: {
        dsp_username: [
          { required: true, message: "DSP username is required", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    fetchSettings() {
      this.formData.dsp_username = localStorage.getItem("dsp_username") || "";
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          localStorage.setItem("dsp_username", this.formData.dsp_username);
          this.$Message.success("Settings updated successfully");
        }
      });
    }
  },
  mounted() {
    this.fetchSettings();
  }
};
</script>

<style lang="scss" scoped>
.box {
  padding: 20px;
}
</style> 


// WEBPACK FOOTER //
// src/pages/setting.vue